import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './locales';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // 기본 언어: 한국어
    lng: 'ko',
    fallbackLng: 'ko',
    debug: false,
    
    // 브라우저 언어 감지 설정
    detection: {
      // 언어 감지 순서: localStorage -> navigator -> htmlTag
      order: ['localStorage', 'navigator', 'htmlTag'],
      // localStorage에 저장할 키 이름
      lookupLocalStorage: 'i18nextLng',
      // 감지된 언어를 localStorage에 캐시
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    // 지원하는 언어 목록
    supportedLngs: ['ko', 'en'],
    
    // 누락된 키 처리 - 디버깅용으로 키 자체를 표시
    saveMissing: false,
    missingKeyHandler: (lng, _ns, key) => {
      console.warn(`Missing translation key: ${key} for language: ${lng}`);
    },
  });

export default i18n;
